import { StoreState } from '@/core/models/store.interface';
import { CancelToken } from 'axios';
import { Module } from 'vuex';
import { MediumTypeKey } from '../availability-todo/availability-todo.interface';
import { CandidatePool } from '../candidate-pool/candidate-pool.interface';
import { SlotStateKey } from '../slot-state/slot-state.interface';
import { Slot } from './slot.interface';
import slotService from './slot.service';

export interface SlotState {
   slots: Array<Slot>;
   slot_state_keys?: Array<SlotStateKey>;
}

const SlotStore: Module<SlotState, StoreState> = {
   namespaced: true,

   state: {
      slots: [],
   },

   getters: {},

   mutations: {
      setSlots(state, slots) {
         state.slots = slots;
      },
   },
   actions: {
      async get(
         context,
         {
            squad_filter_id,
            board_id,
            candidate_id,
            slot_state_keys,
            date_between,
            sorts,
            includes,
            page = 1,
            per_page = 40,
            cancel_token,
            with_time_registration,
         }: {
            squad_filter_id?: number;
            board_id?: number;
            candidate_id?: number;
            slot_state_keys?: string;
            date_between?: string;
            sorts?: string;
            includes?: Array<string>;
            page: number;
            per_page: number;
            cancel_token?: CancelToken;
            with_time_registration?: boolean;
         },
      ) {
         return await slotService
            .get({
               squad_filter_id,
               board_id,
               candidate_id,
               slot_state_keys,
               date_between,
               sorts,
               includes,
               page,
               per_page,
               cancel_token,
               with_time_registration,
            })
            .then((response) => {
               return response;
            });
      },
      async getBulkMove(context, { target_squad_id, slot_ids }: { target_squad_id: number; slot_ids: Array<number> }) {
         return await slotService.getBulkMove(target_squad_id, slot_ids);
      },
      async postBulkPlanning(
         context,
         {
            boardId,
            slot_state_key,
            medium_type_key,
            candidate_pools,
            start_date,
            end_date,
         }: {
            boardId: number;
            slot_state_key: SlotStateKey;
            medium_type_key: MediumTypeKey;
            candidate_pools: Array<CandidatePool>;
            start_date?: string;
            end_date?: string;
         },
      ) {
         const BODY = { slot_state_key, medium_type_key, candidate_pools, start_date, end_date };
         return await slotService.postBulkPlanning(boardId, BODY);
      },
      async postBulkPresence(
         context,
         {
            boardId,
            slot_state_key,
            slot_ids,
            candidate_pools,
            started_at_by_shift_date,
         }: {
            boardId: number;
            slot_state_key: SlotStateKey;
            slot_ids?: Array<number>;
            candidate_pools: Array<CandidatePool>;
            started_at_by_shift_date?: Record<string, string>;
         },
      ) {
         const BODY = { slot_state_key, slot_ids, candidate_pools, started_at_by_shift_date };
         return await slotService.postBulkPresence(boardId, BODY);
      },
      async postBulkMove(context, { shifts, medium_type_key, target_slot_state_key, target_squad_id, slot_ids }) {
         const BODY = { shifts, medium_type_key, target_slot_state_key, target_squad_id, slot_ids };
         return await slotService.postBulkMove(BODY);
      },
      async postPredict(context, { board_id, shift_ids, technique_key }) {
         const BODY = { board_id, shift_ids, technique_key };
         return await slotService.postPredict(BODY).then((response) => {
            return response;
         });
      },
      async createOrUpdate(context, { shift_id, candidate_pool_id }) {
         const BODY = { shift_id, candidate_pool_id };
         return await slotService.createOrUpdate(BODY);
      },
   },
};

export default SlotStore;
